module.exports = __webpack_public_path__ + "img/edit-slate-icon.3a8ca577.svg";